export const fieldTranslations = {
  // Fields for transaction
  date: "Date de la transaction",
  k2_portfolio_name: "Compte",
  k2_static_datum_name: "Actif",
  market_value_ptf_ccy: "Montant en devise de reporting",
  market_value_local_ccy: "Montant en devise locale",
  quantity: "Quantité",
  transfer: "Type de transfert",
  category: "Type de mouvement",
  description: "Description du mouvement",

  // Fees fields
  fee_currency: "Devise du frais",
  broker_fee: "Frais de courtage",
  custodian_broker_fee: "Frais de courtage dépositaire",
  other_fee: "Autres frais",
  fees: "Total des frais",
  fee_type: "Type de frais",

  // Technical fields
  k2_portfolio_id: "ID du portefeuille",
  k2_static_datum_id: "ID de l'actif",
  k2_portfolio_account_type: "Type de compte",
  k2_static_datum_asset_class_1: "Classe d'actif principale",
  k2_static_datum_asset_class_2: "Sous-classe d'actif",
  k2_portfolio_currency: "Devise du portefeuille",
  k2_static_datum_currency: "Devise de l'actif",
  created_at: "Créé le",
  updated_at: "Mis à jour le",
  time_serie_file_id: "ID du fichier de série temporelle",
};
